import { render } from "./POIpageBanner.vue?vue&type=template&id=3da77f81"
import script from "./POIpageBanner.vue?vue&type=script&lang=js"
export * from "./POIpageBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__